export const useLocalStorage = <T>(id: string) => {
  const dataStr = localStorage.getItem(id);
  const obj = dataStr ? (JSON.parse(dataStr) as T) : undefined;

  return {
    data: obj,
    set: (data: T) => localStorage.setItem(id, JSON.stringify(data)),
    remove: () => {
      localStorage.removeItem(id);
      return obj;
    },
  };
};
